var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.721,
    height: 15.399,
    viewBox: "0 0 7.721 15.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pagination_previous",
    "data-name": "pagination previous",
    d: "M1564.59,1052.807l-5.311,6.169,5.311,6.412",
    transform: "translate(-1558.279 -1051.397)",
    fill: "none",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationPrevious);
export default __webpack_public_path__ + "static/media/pagination-previous.1481beab3188d1dd0d312c7f7476cfe3.svg";
export { ForwardRef as ReactComponent };